import { useMemo, lazy, Suspense } from 'react'
import Loading from '@/components/shared/Loading'
import { useAppSelector } from '@/store'
import {
    LAYOUT_TYPE_CLASSIC,
    LAYOUT_TYPE_MODERN,
    LAYOUT_TYPE_SIMPLE,
    LAYOUT_TYPE_STACKED_SIDE,
    LAYOUT_TYPE_DECKED,
    LAYOUT_TYPE_BLANK,
} from '@/constants/theme.constant'
import useAuth from '@/hooks/useAuth'
import useDirection from '@/hooks/useDirection'
import useLocale from '@/hooks/useLocale'
import usePartnersFetch from '@/hooks/usePartnersFetch'
import useDomainsFetch from '@/hooks/useDomainsFetch'
import useScriptsFetch from '@/hooks/useScriptsFetch'
import useCurrenciesFetch from '@/hooks/useCurrenciesFetch'
import useIndustriesFetch from '@/hooks/useIndustriesFetch'
import useAutomationsFetch from '@/hooks/useAutomationsFetch'
import useCompaniesFetch from '@/hooks/useCompaniesFetch'
import useSectorsFetch from '@/hooks/useSectorsFetch'
import useMasterPartnersFetch from '@/hooks/useMasterPartnersFetch'
import { useUser } from '@/hooks/useUser'

const layouts = {
    [LAYOUT_TYPE_CLASSIC]: lazy(() => import('./ClassicLayout')),
    [LAYOUT_TYPE_MODERN]: lazy(() => import('./ModernLayout')),
    [LAYOUT_TYPE_STACKED_SIDE]: lazy(() => import('./StackedSideLayout')),
    [LAYOUT_TYPE_SIMPLE]: lazy(() => import('./SimpleLayout')),
    [LAYOUT_TYPE_DECKED]: lazy(() => import('./DeckedLayout')),
    [LAYOUT_TYPE_BLANK]: lazy(() => import('./BlankLayout')),
}

const AuthenticatedDataPrefetch = () => {
    usePartnersFetch()
    useDomainsFetch()
    useScriptsFetch()
    useCurrenciesFetch()
    useIndustriesFetch()
    useAutomationsFetch()
    useCompaniesFetch()
    useSectorsFetch()
    useMasterPartnersFetch()
    return null
}

const Layout = () => {
    
    const layoutType = useAppSelector((state) => state.theme.layout.type)
    const { authenticated } = useAuth()
    const { awaitingDomainAccess } = useUser()
   
    useDirection()
    useLocale()

    const AppLayout = useMemo(() => {
        if (authenticated) {
            return layouts[layoutType]
        }
        return lazy(() => import('./AuthLayout'))
    }, [layoutType, authenticated])

    

    return (
            <>
            {authenticated && !awaitingDomainAccess ? <AuthenticatedDataPrefetch /> : null}
            <Suspense
                fallback={
                    <div className="flex flex-auto flex-col h-[100vh]">
                        <Loading loading={true} />
                    </div>
                }
            >
                <AppLayout />
            </Suspense>
            </>
    )
}

export default Layout
